import React from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import styles from '../ChatBotComponent/ChatBotComponent.module.css'
import MicOffIcon from '@mui/icons-material/MicOff';
import SettingsVoiceIcon from '@mui/icons-material/SettingsVoice';
import { callLogEvent } from '../../Common/Util';

export interface SpeechToTextProps {
    isDisable?: boolean;
    handleChange?: (event: any) => any;
}
const SpeechToText = ({ isDisable = false, handleChange }: SpeechToTextProps) => {
    const {
        transcript,
        finalTranscript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition,
    } = useSpeechRecognition();

    if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
    }

    const startListening = () => {
        SpeechRecognition.startListening();
        callLogEvent("CLICKED_ON_NEW_DAILOG_CHATBOX_MIC_ENABLE_BUTTON","Clicked to enable speech to text button");
    };

    const stopListening = () => {
        SpeechRecognition.stopListening();
        callLogEvent("CLICKED_ON_NEW_DAILOG_CHATBOX_MIC_DISABLE_BUTTON","Clicked to disable speech to text button");
    };
    const handleText = () => {
        handleChange && handleChange({ transcript, status: "in_progress" });
        if (transcript && finalTranscript && transcript.length === finalTranscript.length) {
            handleChange && handleChange({ transcript, status: "completed" });
            resetTranscript();
        }
    }

    transcript && handleText()
    // transcript && handleChange && handleChange({ transcript, finalTranscript });
    return (
        <span style={{marginBottom: "10px"}}>
            {listening ? <SettingsVoiceIcon onClick={stopListening} className={styles.disableMicBtn} /> : <MicOffIcon className={isDisable ? styles.activeMicIcon : styles.disableMicBtn} onClick={isDisable ? resetTranscript : startListening} />}


        </span>
    );
};

export default SpeechToText;
